import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Search, Library, User } from 'lucide-react';
import { motion } from 'framer-motion';
import { usePlayer } from '../context/PlayerContext';

interface NavItem {
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const navItems: NavItem[] = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/discover', icon: Compass, label: 'Browse' },
  { path: '/search', icon: Search, label: 'Search' },
  { path: '/library', icon: Library, label: 'Library' },
  { path: '/settings', icon: User, label: 'Profile' },
];

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { state: playerState } = usePlayer();
  const hasActiveTrack = !!playerState.currentTrack;

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-stone-200/80 z-30 lg:hidden transition-all duration-300"
      style={{ bottom: hasActiveTrack ? '72px' : '0' }}
    >
      <div className="flex items-center justify-around h-16 px-2 pb-safe">
        {navItems.map((item) => {
          const active = isActive(item.path);
          const Icon = item.icon;

          return (
            <Link
              key={item.path}
              to={item.path}
              className="relative flex flex-col items-center justify-center flex-1 h-full group"
            >
              {active && (
                <motion.div
                  layoutId="mobileActiveTab"
                  className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-royal-gold rounded-b-full"
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
                />
              )}

              <Icon
                className={`w-[22px] h-[22px] transition-colors ${
                  active ? 'text-royal-gold' : 'text-stone-400 group-hover:text-stone-600'
                }`}
              />

              <span
                className={`text-[10px] mt-1 transition-colors ${
                  active ? 'text-royal-gold font-semibold' : 'text-stone-400'
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
